var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoMatches(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 160,
    viewBox: "0 0 119 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.94 27.1602V31.4702",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.79 29.3105H105.09",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.78 10.5293V14.8293",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.62 12.6797H16.93",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.24 2.46C48.7812 2.46 49.22 2.02124 49.22 1.48C49.22 0.93876 48.7812 0.5 48.24 0.5C47.6988 0.5 47.26 0.93876 47.26 1.48C47.26 2.02124 47.6988 2.46 48.24 2.46Z",
    fill: "#CFCFCF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.66 41.4197C71.29 41.4197 62.7699 41.0797 54.7999 38.8597C46.9799 36.6897 39.7999 32.4797 33.3999 27.6097C29.2099 24.4397 25.3999 21.9197 19.9599 22.2997C14.6335 22.5913 9.54234 24.5899 5.43995 27.9997C-1.48005 33.9997 -0.440053 45.2297 2.32995 53.1197C6.48995 64.9997 19.1499 73.2297 29.9099 78.6097C42.3399 84.8197 55.9999 88.4197 69.6899 90.4997C81.6899 92.3197 97.1099 93.6497 107.51 85.8097C117.06 78.6097 119.68 62.1697 117.34 51.0697C116.773 47.7876 115.027 44.8255 112.43 42.7397C105.72 37.8397 95.7099 41.1097 88.1699 41.2797C85.3699 41.3397 82.52 41.4097 79.66 41.4197Z",
    fill: "#F2F2F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.18 109.949C79.4543 109.949 95.89 108.924 95.89 107.659C95.89 106.394 79.4543 105.369 59.18 105.369C38.9056 105.369 22.47 106.394 22.47 107.659C22.47 108.924 38.9056 109.949 59.18 109.949Z",
    fill: "#F2F2F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7727 3.8211L25.8974 10.4293C24.3322 10.6409 23.2348 12.0814 23.4464 13.6467L32.9246 83.7489C33.1363 85.3142 34.5767 86.4115 36.142 86.1999L85.0173 79.5917C86.5826 79.38 87.68 77.9396 87.4683 76.3743L77.9901 6.27211C77.7785 4.70682 76.338 3.60947 74.7727 3.8211Z",
    fill: "#D2D2D2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M91.01 14.1094H41.69C40.1104 14.1094 38.83 15.3898 38.83 16.9694V87.7094C38.83 89.2889 40.1104 90.5694 41.69 90.5694H91.01C92.5895 90.5694 93.87 89.2889 93.87 87.7094V16.9694C93.87 15.3898 92.5895 14.1094 91.01 14.1094Z",
    fill: "white",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2 69.0293H54.49C53.6008 69.0293 52.88 69.7501 52.88 70.6393V70.6493C52.88 71.5385 53.6008 72.2593 54.49 72.2593H78.2C79.0892 72.2593 79.81 71.5385 79.81 70.6493V70.6393C79.81 69.7501 79.0892 69.0293 78.2 69.0293Z",
    fill: "#D2D2D2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M83.15 76.9395H49.64C49.281 76.9395 48.99 77.2305 48.99 77.5894C48.99 77.9484 49.281 78.2394 49.64 78.2394H83.15C83.509 78.2394 83.8 77.9484 83.8 77.5894C83.8 77.2305 83.509 76.9395 83.15 76.9395Z",
    fill: "#D2D2D2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.61 59.3203V63.6303",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.46 61.4707H21.77",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M101.12 62.3702C101.661 62.3702 102.1 61.9314 102.1 61.3902C102.1 60.8489 101.661 60.4102 101.12 60.4102C100.579 60.4102 100.14 60.8489 100.14 61.3902C100.14 61.9314 100.579 62.3702 101.12 62.3702Z",
    fill: "#CFCFCF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M77.16 42.5802C77.16 44.8705 76.4808 47.1093 75.2084 49.0137C73.936 50.918 72.1274 52.4022 70.0115 53.2787C67.8955 54.1551 65.5672 54.3845 63.3209 53.9376C61.0746 53.4908 59.0112 52.3879 57.3917 50.7685C55.7722 49.149 54.6693 47.0856 54.2225 44.8393C53.7757 42.593 54.005 40.2647 54.8815 38.1487C55.7579 36.0327 57.2422 34.2242 59.1465 32.9517C61.0508 31.6793 63.2897 31.0002 65.58 31.0002C67.1029 30.9922 68.6123 31.2863 70.0209 31.8654C71.4294 32.4446 72.7091 33.2972 73.786 34.3741C74.8629 35.451 75.7156 36.7307 76.2947 38.1393C76.8739 39.5478 77.168 41.0572 77.16 42.5802Z",
    fill: "white",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4 50.1113C73.3147 51.3785 71.9681 52.3957 70.4525 53.0931C68.9369 53.7906 67.2883 54.1517 65.62 54.1517C63.9516 54.1517 62.303 53.7906 60.7874 53.0931C59.2719 52.3957 57.9252 51.3785 56.84 50.1113C56.9903 47.8852 57.9807 45.7992 59.6107 44.2755C61.2408 42.7519 63.3887 41.9043 65.62 41.9043C67.8512 41.9043 69.9992 42.7519 71.6292 44.2755C73.2592 45.7992 74.2496 47.8852 74.4 50.1113Z",
    fill: "#D2D2D2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M65.58 40.1508C67.6787 40.1508 69.38 38.4495 69.38 36.3508C69.38 34.2521 67.6787 32.5508 65.58 32.5508C63.4814 32.5508 61.78 34.2521 61.78 36.3508C61.78 38.4495 63.4814 40.1508 65.58 40.1508Z",
    fill: "#D2D2D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMatches);
export default __webpack_public_path__ + "static/media/NoMatches.3ece8bd845126cc0a3086b5cff106907.svg";
export { ForwardRef as ReactComponent };